/**
 * Share — Copy Link to Clipboard
 *
 * Handles click on [data-share-copy-link] buttons.
 * Copies the URL from the data attribute to the clipboard.
 */
const copyTextToClipboard = ( text ) => {
	if ( navigator.clipboard?.writeText ) {
		return navigator.clipboard.writeText( text ).catch( () => {
			const textarea = document.createElement( 'textarea' );
			textarea.value = text;
			textarea.setAttribute( 'readonly', '' );
			textarea.style.position = 'absolute';
			textarea.style.left = '-9999px';

			document.body.appendChild( textarea );
			textarea.select();

			try {
				document.execCommand( 'copy' );
			} finally {
				document.body.removeChild( textarea );
			}
		} );
	}

	return new Promise( ( resolve, reject ) => {
		const textarea = document.createElement( 'textarea' );
		textarea.value = text;
		textarea.setAttribute( 'readonly', '' );
		textarea.style.position = 'absolute';
		textarea.style.left = '-9999px';

		document.body.appendChild( textarea );
		textarea.select();

		try {
			if ( document.execCommand( 'copy' ) ) {
				resolve();
				return;
			}
		} catch ( error ) {
			reject( error );
			return;
		} finally {
			document.body.removeChild( textarea );
		}

		reject( new Error( 'Copy command was unsuccessful.' ) );
	} );
};

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '[data-share-copy-link]' ).forEach( ( button ) => {
		button.addEventListener( 'click', () => {
			const url = button.getAttribute( 'data-share-copy-link' );
			if ( ! url ) return;

			copyTextToClipboard( url ).catch( () => {} );
		} );
	} );
} );
